import melodyA from './TB_Powerup_Melody_A.wav.mp3'
import melodyB from './TB_Powerup_Melody_B.wav.mp3'
import ambienceA from './TB_Powerup_Ambience_A.wav.mp3'
import ambienceB from './TB_Powerup_Ambience_B.wav.mp3'
import effectA from './TB_Powerup_SFX_A.wav.mp3'
import effectB from './TB_Powerup_SFX_B.wav.mp3'

export default {
  melody: {
    a: melodyA,
    b: melodyB,
  },
  ambience: {
    a: ambienceA,
    b: ambienceB,
  },
  effect: {
    a: effectA,
    b: effectB,
  },
}



// WEBPACK FOOTER //
// ./client/components/sounds/power_up/index.js